/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type ActionPriority =
  (typeof ActionPriority)[keyof typeof ActionPriority];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionPriority = {
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
} as const;
